// employee/reducers.ts
const initialState = {
    getTallyData: [],
    getTallyCount: null,
    createTallyData: null,
    updateTallyData: null,
    getTallyMetaMessage: null,
    getTallySuccess: false,
    getTallyFailure: false,
    createTallySuccess: false,
    createTallyFailure: false,
    updateTallySuccess: false,
    updateTallyFailure: false,
    deleteTallySuccess: false,
    deleteTallyFailure: false,
};

export default function tallyReducer(state = initialState, action: any) {
    switch (action.type) {
        case 'GET_TALLY_SUCCESS': {
            return {
                ...state,
                getTallySuccess: true,
                getTallyData: action.payload?.data?.data?.data,
                getTallyCount:action.payload?.data?.data?.meta?.total,
                getTallyFailure: false,
            };
        }
        case 'GET_TALLY_FAILURE': {
            return {
                ...state,
                getTallyFailure: true,
                getTallyMetaMessage: action.payload?.data?.data?.meta?.message,
                getTallySuccess: false,
            };
        }
        case 'RESET_GET_TALLY': {
            return {
                ...state,
                getTallySuccess: false,
                getTallyFailure: false,
                getTallyData: [],
                getTallyMetaMessage: null,
            };
        }

        case 'CREATE_TALLY_SUCCESS': {
            return {
                ...state,
                createTallySuccess: true,
                createTallyData: action.payload?.data?.data?.data,
                getTallyMetaMessage: action.payload?.data?.data?.meta?.message,
                createTallyFailure: false,
            };
        }
        case 'CREATE_TALLY_FAILURE': {
            return {
                ...state,
                createTallyFailure: true,
                getTallyMetaMessage: action.payload?.data?.data?.meta?.message,
                createTallySuccess: false,
            };
        }
        case 'RESET_CREATE_TALLY': {
            return {
                ...state,
                createTallySuccess: false,
                createTallyFailure: false,
                createTallyData: null,
                getTallyMetaMessage: null,
            };
        }

        case 'UPDATE_TALLY_SUCCESS': {
            return {
                ...state,
                updateTallySuccess: true,
                updateTallyData: action.payload?.data?.data?.data,
                getTallyMetaMessage: action.payload?.data?.data?.meta?.message,
                updateTallyFailure: false,
            };
        }
        case 'UPDATE_TALLY_FAILURE': {
            return {
                ...state,
                updateTallyFailure: true,
                getTallyMetaMessage: action.payload?.data?.data?.meta?.message,
                updateTallySuccess: false,
            };
        }
        case 'RESET_UPDATE_TALLY': {
            return {
                ...state,
                updateTallySuccess: false,
                updateTallyFailure: false,
                updateTallyData: null,
                getTallyMetaMessage: null,
            };
        }

        case 'DELETE_TALLY_SUCCESS': {
            return {
                ...state,
                deleteTallySuccess: true,
                getTallyMetaMessage: action.payload?.data?.data?.meta?.message,
                deleteTallyFailure: false,
            };
        }
        case 'DELETE_TALLY_FAILURE': {
            return {
                ...state,
                deleteTallyFailure: true,
                getTallyMetaMessage: action.payload?.data?.data?.meta?.message,
                deleteTallySuccess: false,
            };
        }
        case 'RESET_DELETE_TALLY': {
            return {
                ...state,
                deleteTallySuccess: false,
                deleteTallyFailure: false,
                getTallyMetaMessage: null,
            };
        }

        default: {
            return state;
        }
    }
}
